// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"244":"fb5d8fdf","567":"c5cc6b72","920":"a1257647"}[chunkId] + ".chunk.css";
};